<template>
  <v-text-field
    v-model="inputValue"
    :rules="rules"
    variant="outlined"
    density="compact"
  ></v-text-field>
</template>

<script>
import validator from "@/helper/validator";
export default {
  name: "emailCard",
  props: {
    modelValue: String,
  },
  data: () => ({
    rules: [validator.required, validator.email],
  }),
  computed: {
    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
